<template>
  <div class="timeData">
    <div class="rowA">
      <div>
        <div class="english">RALTIMEDATA</div>
      </div>
      <div class="chinese">实时数据</div>
    </div>
    <div class="rowB">
      <!-- <div class="topFont">武夷山竹筏票实时预报</div> -->
      <div class="tableTop" style="margin-top:0px">
        <div>
          <div class="topFont" style="float:left">武夷山竹筏票实时预报</div>
          <img src="@/assets/image/refresh.png" class="refreshImg" />
          <div class="refreshFont" @click="handleData">刷新</div>
        </div>
      </div>
      <!-- 表格一 -->
      <div class="tableColumn">
        <div class="tableHeader">
          <div class="tableHeaderA">趟次时间</div>
          <div class="tableHeaderA">已售</div>
          <div class="tableHeaderA">可售</div>
          <div class="tableHeaderA">状态</div>
        </div>
        <div class="box_body" style="height:36.066vh" v-loading="loading">
          <div v-for="item in list" :key="item.id" class="tableRow">
            <div class="tableBody ">{{ item.time }}</div>
            <div class="tableBody ">{{ item.saleNum }}</div>
            <div class="tableBody ">{{ item.restNum }}</div>
            <div class="tableBody ">{{ item.statusName }}</div>
          </div>
        </div>
      </div>
      <!-- 温馨提示 -->
      <div class="tableColumn">
        <div class="fontSizeA">温馨提示：</div>
        <div class="table-tips">
          {{ hintWarm }}
        </div>
        <!-- <div class="fontSizeA">温馨提示：</div>
        <div class="fontSizeB">
          1、表中所列数据系签约旅行社和售票窗口的销售情况；
        </div>
        <div class="fontSizeB">2、购票后请到候筏大厅组拼；</div>
        <div class="fontSizeB">3、当趟次单竹排在开排前40-60分钟开始销售；</div>
        <div class="fontSizeB">
          4、为了您和他人的旅游安全，严禁带水枪、水瓢、捞网等乘坐竹筏，谢谢您的配合。
        </div> -->
      </div>
      <!-- 表格二 -->
      <div class="tableTop">
        <div>
          <div class="topFont" style="float:left">未来3天游客预订统计</div>
          <img src="@/assets/image/refresh.png" class="refreshImg" />
          <div class="refreshFont" @click="handleBookingData">刷新</div>
        </div>
      </div>

      <div class="tableColumn">
        <div class="tableHeader">
          <div class="tableHeaderA">今日销售总数</div>
          <div class="tableHeaderA">第一天预订数</div>
          <div class="tableHeaderA">第二天预订数</div>
          <div class="tableHeaderA">第三天预订数</div>
        </div>
        <div class="box_body">
          <div
            v-for="item in salelist"
            :key="item.id"
            class="tableRow"
            v-loading="bookloading"
          >
            <div class="tableBody ">{{ todaySaleNum }}</div>
            <div class="tableBody ">{{ reservationOneDay }}</div>
            <div class="tableBody ">{{ reservationTwoDay }}</div>
            <div class="tableBody ">{{ reservationThreeDay }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="rowC"
      style="margin-top:2.685vh;margin-left:9.0%;margin-right:1.0416vw"
    >
      <div class="layout">
        <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
          <div style="margin-top:1.018vh;">武夷山景区</div>
          <div style="margin-top:1.018vh;">天下难寻</div>
          <div style="margin-top:1.018vh;">Wuyi</div>
          <div>Mountain</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRealTimeData } from "@/api/common";
export default {
  name: "RealTimeData",
  data() {
    return {
      salelist: [{ id: 1 }],
      list: [],
      todaySaleNum: 0,
      reservationOneDay: 0,
      reservationTwoDay: 0,
      reservationThreeDay: 0,
      hintWarm: "",
      loading: false,
      bookloading: false
    };
  },
  mounted() {
    this.getRealTimeDataSource();
  },
  methods: {
    async getRealTimeDataSource() {
      let info = {};
      info.tenantId = "8f22645b0bf9d6a78ab47d99fb5c8cff";
      info.merchId = "af724ffbe0cf4f1fbfd3d059ecf31c0b";
      const { data, code } = await getRealTimeData(info);
      if (code == 0) {
        this.list = data.timesInfoList;
        this.todaySaleNum = data.todaySaleNum;
        this.reservationOneDay = data.reservationOneDay;
        this.reservationTwoDay = data.reservationTwoDay;
        this.reservationThreeDay = data.reservationThreeDay;
        this.hintWarm = data.hintWarm;
      }
    },
    handleData() {
      this.getRealTimeStatisticsDataSource();
    },
    //统计刷新
    async getRealTimeStatisticsDataSource() {
      let info = {};
      this.list = [];
      this.loading = true;
      info.tenantId = "8f22645b0bf9d6a78ab47d99fb5c8cff";
      info.merchId = "af724ffbe0cf4f1fbfd3d059ecf31c0b";
      const { data, code } = await getRealTimeData(info);
      if (code == 0) {
        this.list = data.timesInfoList;
        this.hintWarm = data.hintWarm;
      }
      var that = this;
      setTimeout(function() {
        that.loading = false;
      }, 1000);
      // this.loading = false;
    },
    handleBookingData() {
      this.getRealTimeDataBookingSource();
    },
    //游客预订刷新
    async getRealTimeDataBookingSource() {
      let info = {};
      info.tenantId = "8f22645b0bf9d6a78ab47d99fb5c8cff";
      info.merchId = "af724ffbe0cf4f1fbfd3d059ecf31c0b";
      this.bookloading = true;
      const { data, code } = await getRealTimeData(info);
      if (code == 0) {
        this.todaySaleNum = data.todaySaleNum;
        this.reservationOneDay = data.reservationOneDay;
        this.reservationTwoDay = data.reservationTwoDay;
        this.reservationThreeDay = data.reservationThreeDay;
        this.hintWarm = data.hintWarm;
      }
      var that = this;
      setTimeout(function() {
        that.bookloading = false;
      }, 1000);
    }
  }
};
</script>

<style scoped>
.timeData {
  height: 85.555vh;
  background: url(../../assets/image/logoBottom.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.timeData .rowA {
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-left: 9.67%;
}
.timeData .rowB {
  width: 100%;
  margin-top: 3.87%;
  margin-left: 4.24%;
  animation: bounceInRight 2s;
}
.timeData .rowC {
  /* width: 30px; */
  padding: 0px 0.3645vw 0px 0.3645vw;
  height: 26.4814vh;
  line-height: 1.574vh;
  background: #d87001;
  /* position: relative; */
  color: #ffffff;
  animation: bounceInRight 2s;
  font-size: 1.2962vh;
}
.timeData .rowC .layout {
}

.timeData .rowB .topFont {
  font-size: 1.66667vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #333333;
  line-height: 1.66667vh;
  margin-bottom: 1.388vh;
}

.timeData .chinese {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  margin-left: 0.833vh;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
.timeData .english {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}

.tableHeader {
  height: 4.62vh;
  background: #cae6e0;
  display: flex;
  flex-direction: row;
  /* width: 87.04%; */
}
.tableHeaderA {
  width: 25%;
  font-size: 1.4814vh;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #4a9183;
  line-height: 1.4814vh;
  text-align: center;
  padding-top: 1.574vh;
  line-height: 1.4814vh;
}

.tableBody {
  width: 25%;
  font-size: 1.4814vh;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #666666;
  font-size: 1.4814vh;
  text-align: center;
  padding-top: 1.574vh;
  line-height: 1.111vh;
  background: #ffffff;
  height: 4.6296vh;
  border-top: 0.0925vh solid #bec9df;
}
.box_body {
  display: flex;
  flex-direction: column;
  /* width: 87.04%; */
  border-bottom: 0.0925vh solid #bec9df;
  border-left: 0.0925vh solid #bec9df;
  border-right: 0.0925vh solid #bec9df;
  overflow-y: scroll;
}
.box_body::-webkit-scrollbar {
  width: 0.18vw;
  /*height: 4px;*/
}
/* 滑块 */
.box_body::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #c1c1c1;
}
/* 滑槽 */
.box_body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  background: rgba(0, 94, 154, 0);
}
.tableRow {
  display: flex;
  flex-direction: row;
}
.tableColumn {
  display: flex;
  flex-direction: column;
}
.tableColumn .fontSizeA {
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #d87001;
  padding-top: 1.296vh;
}
.tableColumn .fontSizeB {
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #888888;
}
.refreshImg {
  width: 2.222vh;
  height: 2.222vh;
  position: absolute;
  z-index: 0;
  float: right;
  right: 2.135vw;
}
.refreshFont {
  line-height: 1.4814vh;
  font-size: 1.4814vh;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #4a9183;
  padding-top: 0.4629vh;
  padding-left: 0.46875vw;
  position: absolute;
  z-index: 0;
  float: right;
  right: 0px;
}
.tableTop {
  display: flex;
  flex-direction: row;
  margin-top: 3.703vh;
  position: relative;
  cursor: pointer;
  /* width: 87.04%; */
}
.table-tips {
  width: 100%;
  height: 9.259vh;
  word-wrap: break-word;
  overflow: hidden;
  /* text-overflow: ellipsis; */
}
</style>



// WEBPACK FOOTER //
// src/views/realTimeData/index.vue